import React, { FC } from 'react'
import Badge, { BADGE_SIZE } from 'transfix-ui/components/Badge'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const usePillStyles = makeStyles(({ spacing, typography }) => ({
  root: {
    fontWeight: typography.fontWeightMedium,
    fontSize: '14px',
    padding: spacing(0.5, 1.5),
    width: 'auto',
    height: '30px',
    borderRadius: '14px',
  },
  info: {
    border: `1px solid ${brandColors.infoMedium}`,
    backgroundColor: brandColors.white,
    color: brandColors.infoDark,
  },
  success: {
    color: brandColors.green3,
    backgroundColor: brandColors.green1,
  },
  error: {
    color: brandColors.error1,
    backgroundColor: brandColors.error0,
  },
}))

export interface IPillProps {
  label: string
  variant?: 'info' | 'success' | 'error'
}

export const Pill: FC<IPillProps> = ({ label, variant = 'info' }) => {
  const classes = usePillStyles()
  return (
    <Badge
      className={`${classes.root} ${classes[variant]}`}
      label={label}
      size={BADGE_SIZE.medium}
    />
  )
}
